module.exports = __webpack_public_path__ + "img/personal.5377056f.jpg";